import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CAL_LINK = "https://cal.com/kalza-studio-hdho6x";

export default function CaseStudiesPage() {
  return (
    <main data-testid="case-studies-page">
      <section className="pt-32 pb-20 md:pb-28 bg-[#F5F0EB]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="mb-6">
              <span className="font-display text-4xl md:text-5xl text-[#1C1210] block">THE WORK</span>
              <span className="font-accent text-4xl md:text-5xl text-[#BE123C] block mt-1">speaks.</span>
            </h1>
            <p className="font-body text-base md:text-lg text-[#6B6560] leading-relaxed max-w-xl">
              Real clients. Real shifts. What happens when the brand catches up with the business.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Placeholder */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center py-16">
            <p className="font-serif text-2xl text-[#1C1210] mb-4">Case studies coming soon.</p>
            <p className="font-body text-base text-[#6B6560] mb-8 max-w-md mx-auto">
              In the meantime, if you want to hear what working with me is like, book a call and I'll share real client feedback directly.
            </p>
            <a href={CAL_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-8 py-4 rounded-full hover:bg-[#9F1239] transition-colors duration-300">
              BOOK A FREE CALL <ArrowUpRight size={16} />
            </a>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
